/**
 * Generated by orval v8.5.2 🍺
 * Do not edit manually.
 * Alchemer Dashboard API
 * OpenAPI spec version: 1.0.155
 */
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AliasResponseSchema,
  CreateAliasApiRequestSchema,
  CreateAliasV1Auth0AliasesParams,
  CreateDigitalModelRequestSchema,
  CreateModelRequestSchema,
  CreateMultiSurveyModelRequestSchema,
  DeleteAliasResponseSchema,
  DeleteAliasV1Auth0AliasesIdParams,
  ErrorAuthorizationSchema,
  ErrorInternalSchema,
  ErrorNotFoundSchema,
  ErrorRateLimitSchema,
  ErrorValidationSchema,
  GetAliasListResponseSchema,
  GetAliasListV1Auth0AliasesParams,
  GetCategoriesListResponseSchema,
  GetCategoriesListV1Auth0Params,
  GetDefaultAliasListV1Auth0AliasesParams,
  HTTPValidationError,
  HealthSchema,
  JobEnqueueResponseSchema,
  JobStatusResponseSchema,
  PreviewSurveyMergeRequestSchema,
  PreviewSurveyMergeResponseSchema,
  SDKTokenResponseSchema,
  ShareGetUsersResponseSchema,
  ShareRequestSchema,
  ShareResponseSchema,
  ThoughtspotDeleteModelConflictResponseSchema,
  ThoughtspotUserEmailUpdateRequestSchema,
  ThoughtspotUserEmailUpdateResponseSchema,
  UpdateAliasApiRequestSchema,
  UpdateAliasV1Auth0AliasesIdParams,
  UpdateDigitalModelRequestSchema,
} from '../schemas';

import { IgniteAxiosClient } from '../../mutators/IgniteAxiosClient';

/**
 * @summary Health
 */
export const health = () => {
  return IgniteAxiosClient<HealthSchema>({ url: `/dashboard/health`, method: 'GET' });
};

export const getHealthInfiniteQueryKey = () => {
  return ['infinite', `/dashboard/health`] as const;
};

export const getHealthQueryKey = () => {
  return [`/dashboard/health`] as const;
};

export const getHealthInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof health>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof health>>> = () => health();

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof health>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HealthInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof health>>>;
export type HealthInfiniteQueryError = unknown;

export function useHealthInfinite<TData = InfiniteData<Awaited<ReturnType<typeof health>>>, TError = unknown>(
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof health>>, TError, Awaited<ReturnType<typeof health>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthInfinite<TData = InfiniteData<Awaited<ReturnType<typeof health>>>, TError = unknown>(
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof health>>, TError, Awaited<ReturnType<typeof health>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthInfinite<TData = InfiniteData<Awaited<ReturnType<typeof health>>>, TError = unknown>(
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Health
 */

export function useHealthInfinite<TData = InfiniteData<Awaited<ReturnType<typeof health>>>, TError = unknown>(
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHealthInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getHealthQueryOptions = <TData = Awaited<ReturnType<typeof health>>, TError = unknown>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof health>>> = () => health();

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof health>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HealthQueryResult = NonNullable<Awaited<ReturnType<typeof health>>>;
export type HealthQueryError = unknown;

export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof health>>, TError, Awaited<ReturnType<typeof health>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof health>>, TError, Awaited<ReturnType<typeof health>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Health
 */

export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHealthQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get Sdk Token
 */
export const getSdkToken = () => {
  return IgniteAxiosClient<SDKTokenResponseSchema>({ url: `/dashboard/dashboard/get-sdk-token`, method: 'GET' });
};

export const getGetSdkTokenInfiniteQueryKey = () => {
  return ['infinite', `/dashboard/dashboard/get-sdk-token`] as const;
};

export const getGetSdkTokenQueryKey = () => {
  return [`/dashboard/dashboard/get-sdk-token`] as const;
};

export const getGetSdkTokenInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getSdkToken>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(options?: {
  query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSdkToken>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSdkTokenInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSdkToken>>> = () => getSdkToken();

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSdkToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSdkTokenInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSdkToken>>>;
export type GetSdkTokenInfiniteQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useGetSdkTokenInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSdkToken>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSdkToken>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSdkToken>>,
          TError,
          Awaited<ReturnType<typeof getSdkToken>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSdkTokenInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSdkToken>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSdkToken>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSdkToken>>,
          TError,
          Awaited<ReturnType<typeof getSdkToken>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSdkTokenInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSdkToken>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSdkToken>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Sdk Token
 */

export function useGetSdkTokenInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSdkToken>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSdkToken>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSdkTokenInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetSdkTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getSdkToken>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSdkToken>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSdkTokenQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSdkToken>>> = () => getSdkToken();

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSdkToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSdkTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getSdkToken>>>;
export type GetSdkTokenQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useGetSdkToken<
  TData = Awaited<ReturnType<typeof getSdkToken>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSdkToken>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSdkToken>>,
          TError,
          Awaited<ReturnType<typeof getSdkToken>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSdkToken<
  TData = Awaited<ReturnType<typeof getSdkToken>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSdkToken>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSdkToken>>,
          TError,
          Awaited<ReturnType<typeof getSdkToken>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSdkToken<
  TData = Awaited<ReturnType<typeof getSdkToken>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSdkToken>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Sdk Token
 */

export function useGetSdkToken<
  TData = Awaited<ReturnType<typeof getSdkToken>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSdkToken>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSdkTokenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create Model
 */
export const createModel = (createModelRequestSchema: CreateModelRequestSchema) => {
  return IgniteAxiosClient<JobEnqueueResponseSchema>({
    url: `/dashboard/dashboard/create-model`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createModelRequestSchema,
  });
};

export const getCreateModelMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModel>>,
    TError,
    { data: CreateModelRequestSchema },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createModel>>,
  TError,
  { data: CreateModelRequestSchema },
  TContext
> => {
  const mutationKey = ['createModel'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createModel>>, { data: CreateModelRequestSchema }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return createModel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateModelMutationResult = NonNullable<Awaited<ReturnType<typeof createModel>>>;
export type CreateModelMutationBody = CreateModelRequestSchema;
export type CreateModelMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Create Model
 */
export const useCreateModel = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createModel>>,
      TError,
      { data: CreateModelRequestSchema },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof createModel>>, TError, { data: CreateModelRequestSchema }, TContext> => {
  return useMutation(getCreateModelMutationOptions(options), queryClient);
};

/**
 * @summary Update Thoughtspot Model
 */
export const updateThoughtspotModelGuid = (guid: string, createModelRequestSchema: CreateModelRequestSchema) => {
  return IgniteAxiosClient<JobEnqueueResponseSchema>({
    url: `/dashboard/dashboard/update-model/${guid}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: createModelRequestSchema,
  });
};

export const getUpdateThoughtspotModelGuidMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateThoughtspotModelGuid>>,
    TError,
    { guid: string; data: CreateModelRequestSchema },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateThoughtspotModelGuid>>,
  TError,
  { guid: string; data: CreateModelRequestSchema },
  TContext
> => {
  const mutationKey = ['updateThoughtspotModelGuid'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateThoughtspotModelGuid>>,
    { guid: string; data: CreateModelRequestSchema }
  > = (props) => {
    const { guid, data } = props ?? {};

    return updateThoughtspotModelGuid(guid, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateThoughtspotModelGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateThoughtspotModelGuid>>
>;
export type UpdateThoughtspotModelGuidMutationBody = CreateModelRequestSchema;
export type UpdateThoughtspotModelGuidMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Update Thoughtspot Model
 */
export const useUpdateThoughtspotModelGuid = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateThoughtspotModelGuid>>,
      TError,
      { guid: string; data: CreateModelRequestSchema },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateThoughtspotModelGuid>>,
  TError,
  { guid: string; data: CreateModelRequestSchema },
  TContext
> => {
  return useMutation(getUpdateThoughtspotModelGuidMutationOptions(options), queryClient);
};

/**
 * Preview survey merge endpoint - returns question labels that will be merged.

Request body:
    - accountId: Account ID owning the surveys
    - surveyIds: List of survey IDs to merge

Returns:
    - mergeLabels: List of question label strings
 * @summary Preview Survey Merge
 */
export const previewSurveyMerge = (previewSurveyMergeRequestSchema: PreviewSurveyMergeRequestSchema) => {
  return IgniteAxiosClient<PreviewSurveyMergeResponseSchema>({
    url: `/dashboard/dashboard/preview-survey-merge`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: previewSurveyMergeRequestSchema,
  });
};

export const getPreviewSurveyMergeMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewSurveyMerge>>,
    TError,
    { data: PreviewSurveyMergeRequestSchema },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewSurveyMerge>>,
  TError,
  { data: PreviewSurveyMergeRequestSchema },
  TContext
> => {
  const mutationKey = ['previewSurveyMerge'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewSurveyMerge>>,
    { data: PreviewSurveyMergeRequestSchema }
  > = (props) => {
    const { data } = props ?? {};

    return previewSurveyMerge(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewSurveyMergeMutationResult = NonNullable<Awaited<ReturnType<typeof previewSurveyMerge>>>;
export type PreviewSurveyMergeMutationBody = PreviewSurveyMergeRequestSchema;
export type PreviewSurveyMergeMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Preview Survey Merge
 */
export const usePreviewSurveyMerge = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewSurveyMerge>>,
      TError,
      { data: PreviewSurveyMergeRequestSchema },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof previewSurveyMerge>>,
  TError,
  { data: PreviewSurveyMergeRequestSchema },
  TContext
> => {
  return useMutation(getPreviewSurveyMergeMutationOptions(options), queryClient);
};

/**
 * @summary Create Multi Survey Model
 */
export const createMultiSurveyModel = (createMultiSurveyModelRequestSchema: CreateMultiSurveyModelRequestSchema) => {
  return IgniteAxiosClient<JobEnqueueResponseSchema>({
    url: `/dashboard/dashboard/create-multi-survey-model`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createMultiSurveyModelRequestSchema,
  });
};

export const getCreateMultiSurveyModelMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMultiSurveyModel>>,
    TError,
    { data: CreateMultiSurveyModelRequestSchema },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMultiSurveyModel>>,
  TError,
  { data: CreateMultiSurveyModelRequestSchema },
  TContext
> => {
  const mutationKey = ['createMultiSurveyModel'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMultiSurveyModel>>,
    { data: CreateMultiSurveyModelRequestSchema }
  > = (props) => {
    const { data } = props ?? {};

    return createMultiSurveyModel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMultiSurveyModelMutationResult = NonNullable<Awaited<ReturnType<typeof createMultiSurveyModel>>>;
export type CreateMultiSurveyModelMutationBody = CreateMultiSurveyModelRequestSchema;
export type CreateMultiSurveyModelMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Create Multi Survey Model
 */
export const useCreateMultiSurveyModel = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createMultiSurveyModel>>,
      TError,
      { data: CreateMultiSurveyModelRequestSchema },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createMultiSurveyModel>>,
  TError,
  { data: CreateMultiSurveyModelRequestSchema },
  TContext
> => {
  return useMutation(getCreateMultiSurveyModelMutationOptions(options), queryClient);
};

/**
 * @summary Update Multi Survey Model
 */
export const updateMultiSurveyModelGuid = (
  guid: string,
  createMultiSurveyModelRequestSchema: CreateMultiSurveyModelRequestSchema,
) => {
  return IgniteAxiosClient<JobEnqueueResponseSchema>({
    url: `/dashboard/dashboard/update-multi-survey-model/${guid}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: createMultiSurveyModelRequestSchema,
  });
};

export const getUpdateMultiSurveyModelGuidMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMultiSurveyModelGuid>>,
    TError,
    { guid: string; data: CreateMultiSurveyModelRequestSchema },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMultiSurveyModelGuid>>,
  TError,
  { guid: string; data: CreateMultiSurveyModelRequestSchema },
  TContext
> => {
  const mutationKey = ['updateMultiSurveyModelGuid'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMultiSurveyModelGuid>>,
    { guid: string; data: CreateMultiSurveyModelRequestSchema }
  > = (props) => {
    const { guid, data } = props ?? {};

    return updateMultiSurveyModelGuid(guid, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMultiSurveyModelGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMultiSurveyModelGuid>>
>;
export type UpdateMultiSurveyModelGuidMutationBody = CreateMultiSurveyModelRequestSchema;
export type UpdateMultiSurveyModelGuidMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Update Multi Survey Model
 */
export const useUpdateMultiSurveyModelGuid = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMultiSurveyModelGuid>>,
      TError,
      { guid: string; data: CreateMultiSurveyModelRequestSchema },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMultiSurveyModelGuid>>,
  TError,
  { guid: string; data: CreateMultiSurveyModelRequestSchema },
  TContext
> => {
  return useMutation(getUpdateMultiSurveyModelGuidMutationOptions(options), queryClient);
};

/**
 * @summary Delete Model
 */
export const deleteModelGuid = (guid: string) => {
  return IgniteAxiosClient<unknown>({ url: `/dashboard/dashboard/delete-model/${guid}`, method: 'DELETE' });
};

export const getDeleteModelGuidMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ThoughtspotDeleteModelConflictResponseSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteModelGuid>>, TError, { guid: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteModelGuid>>, TError, { guid: string }, TContext> => {
  const mutationKey = ['deleteModelGuid'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteModelGuid>>, { guid: string }> = (props) => {
    const { guid } = props ?? {};

    return deleteModelGuid(guid);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteModelGuidMutationResult = NonNullable<Awaited<ReturnType<typeof deleteModelGuid>>>;

export type DeleteModelGuidMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ThoughtspotDeleteModelConflictResponseSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Delete Model
 */
export const useDeleteModelGuid = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ThoughtspotDeleteModelConflictResponseSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteModelGuid>>, TError, { guid: string }, TContext>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof deleteModelGuid>>, TError, { guid: string }, TContext> => {
  return useMutation(getDeleteModelGuidMutationOptions(options), queryClient);
};

/**
 * @summary Update Thoughtspot User Email
 */
export const updateThoughtspotUserEmail = (
  thoughtspotUserEmailUpdateRequestSchema: ThoughtspotUserEmailUpdateRequestSchema,
) => {
  return IgniteAxiosClient<ThoughtspotUserEmailUpdateResponseSchema>({
    url: `/dashboard/dashboard/update-thoughtspot-user-email`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: thoughtspotUserEmailUpdateRequestSchema,
  });
};

export const getUpdateThoughtspotUserEmailMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateThoughtspotUserEmail>>,
    TError,
    { data: ThoughtspotUserEmailUpdateRequestSchema },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateThoughtspotUserEmail>>,
  TError,
  { data: ThoughtspotUserEmailUpdateRequestSchema },
  TContext
> => {
  const mutationKey = ['updateThoughtspotUserEmail'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateThoughtspotUserEmail>>,
    { data: ThoughtspotUserEmailUpdateRequestSchema }
  > = (props) => {
    const { data } = props ?? {};

    return updateThoughtspotUserEmail(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateThoughtspotUserEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateThoughtspotUserEmail>>
>;
export type UpdateThoughtspotUserEmailMutationBody = ThoughtspotUserEmailUpdateRequestSchema;
export type UpdateThoughtspotUserEmailMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Update Thoughtspot User Email
 */
export const useUpdateThoughtspotUserEmail = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateThoughtspotUserEmail>>,
      TError,
      { data: ThoughtspotUserEmailUpdateRequestSchema },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateThoughtspotUserEmail>>,
  TError,
  { data: ThoughtspotUserEmailUpdateRequestSchema },
  TContext
> => {
  return useMutation(getUpdateThoughtspotUserEmailMutationOptions(options), queryClient);
};

/**
 * @summary Update Thoughtspot User Email
 */
export const updateThoughtspotUserEmailInternal = (
  thoughtspotUserEmailUpdateRequestSchema: ThoughtspotUserEmailUpdateRequestSchema,
) => {
  return IgniteAxiosClient<ThoughtspotUserEmailUpdateResponseSchema>({
    url: `/dashboard/dashboard/update-thoughtspot-user-email/internal`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: thoughtspotUserEmailUpdateRequestSchema,
  });
};

export const getUpdateThoughtspotUserEmailInternalMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateThoughtspotUserEmailInternal>>,
    TError,
    { data: ThoughtspotUserEmailUpdateRequestSchema },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateThoughtspotUserEmailInternal>>,
  TError,
  { data: ThoughtspotUserEmailUpdateRequestSchema },
  TContext
> => {
  const mutationKey = ['updateThoughtspotUserEmailInternal'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateThoughtspotUserEmailInternal>>,
    { data: ThoughtspotUserEmailUpdateRequestSchema }
  > = (props) => {
    const { data } = props ?? {};

    return updateThoughtspotUserEmailInternal(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateThoughtspotUserEmailInternalMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateThoughtspotUserEmailInternal>>
>;
export type UpdateThoughtspotUserEmailInternalMutationBody = ThoughtspotUserEmailUpdateRequestSchema;
export type UpdateThoughtspotUserEmailInternalMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Update Thoughtspot User Email
 */
export const useUpdateThoughtspotUserEmailInternal = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateThoughtspotUserEmailInternal>>,
      TError,
      { data: ThoughtspotUserEmailUpdateRequestSchema },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateThoughtspotUserEmailInternal>>,
  TError,
  { data: ThoughtspotUserEmailUpdateRequestSchema },
  TContext
> => {
  return useMutation(getUpdateThoughtspotUserEmailInternalMutationOptions(options), queryClient);
};

/**
 * @summary Get Job Status
 */
export const getJobStatusJobsId = (jobId: string) => {
  return IgniteAxiosClient<JobStatusResponseSchema>({ url: `/dashboard/jobs/${jobId}`, method: 'GET' });
};

export const getGetJobStatusJobsIdInfiniteQueryKey = (jobId: string) => {
  return ['infinite', `/dashboard/jobs/${jobId}`] as const;
};

export const getGetJobStatusJobsIdQueryKey = (jobId: string) => {
  return [`/dashboard/jobs/${jobId}`] as const;
};

export const getGetJobStatusJobsIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getJobStatusJobsId>>>,
  TError = HTTPValidationError,
>(
  jobId: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getJobStatusJobsId>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobStatusJobsIdInfiniteQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobStatusJobsId>>> = () => getJobStatusJobsId(jobId);

  return { queryKey, queryFn, enabled: !!jobId, staleTime: 10000, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getJobStatusJobsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetJobStatusJobsIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getJobStatusJobsId>>>;
export type GetJobStatusJobsIdInfiniteQueryError = HTTPValidationError;

export function useGetJobStatusJobsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getJobStatusJobsId>>>,
  TError = HTTPValidationError,
>(
  jobId: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getJobStatusJobsId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobStatusJobsId>>,
          TError,
          Awaited<ReturnType<typeof getJobStatusJobsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetJobStatusJobsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getJobStatusJobsId>>>,
  TError = HTTPValidationError,
>(
  jobId: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getJobStatusJobsId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobStatusJobsId>>,
          TError,
          Awaited<ReturnType<typeof getJobStatusJobsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetJobStatusJobsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getJobStatusJobsId>>>,
  TError = HTTPValidationError,
>(
  jobId: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getJobStatusJobsId>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Job Status
 */

export function useGetJobStatusJobsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getJobStatusJobsId>>>,
  TError = HTTPValidationError,
>(
  jobId: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getJobStatusJobsId>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetJobStatusJobsIdInfiniteQueryOptions(jobId, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetJobStatusJobsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobStatusJobsId>>,
  TError = HTTPValidationError,
>(
  jobId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobStatusJobsId>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobStatusJobsIdQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobStatusJobsId>>> = () => getJobStatusJobsId(jobId);

  return { queryKey, queryFn, enabled: !!jobId, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobStatusJobsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetJobStatusJobsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getJobStatusJobsId>>>;
export type GetJobStatusJobsIdQueryError = HTTPValidationError;

export function useGetJobStatusJobsId<
  TData = Awaited<ReturnType<typeof getJobStatusJobsId>>,
  TError = HTTPValidationError,
>(
  jobId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobStatusJobsId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobStatusJobsId>>,
          TError,
          Awaited<ReturnType<typeof getJobStatusJobsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetJobStatusJobsId<
  TData = Awaited<ReturnType<typeof getJobStatusJobsId>>,
  TError = HTTPValidationError,
>(
  jobId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobStatusJobsId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobStatusJobsId>>,
          TError,
          Awaited<ReturnType<typeof getJobStatusJobsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetJobStatusJobsId<
  TData = Awaited<ReturnType<typeof getJobStatusJobsId>>,
  TError = HTTPValidationError,
>(
  jobId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobStatusJobsId>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Job Status
 */

export function useGetJobStatusJobsId<
  TData = Awaited<ReturnType<typeof getJobStatusJobsId>>,
  TError = HTTPValidationError,
>(
  jobId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobStatusJobsId>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetJobStatusJobsIdQueryOptions(jobId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create Digital Model
 */
export const createDigitalModelV1Auth0ModelsCreatemodelsjobRun = (
  createDigitalModelRequestSchema: CreateDigitalModelRequestSchema,
) => {
  return IgniteAxiosClient<JobEnqueueResponseSchema>({
    url: `/dashboard/v1/auth0/models/createModelsJob/digital:run`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDigitalModelRequestSchema,
  });
};

export const getCreateDigitalModelV1Auth0ModelsCreatemodelsjobRunMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDigitalModelV1Auth0ModelsCreatemodelsjobRun>>,
    TError,
    { data: CreateDigitalModelRequestSchema },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDigitalModelV1Auth0ModelsCreatemodelsjobRun>>,
  TError,
  { data: CreateDigitalModelRequestSchema },
  TContext
> => {
  const mutationKey = ['createDigitalModelV1Auth0ModelsCreatemodelsjobRun'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDigitalModelV1Auth0ModelsCreatemodelsjobRun>>,
    { data: CreateDigitalModelRequestSchema }
  > = (props) => {
    const { data } = props ?? {};

    return createDigitalModelV1Auth0ModelsCreatemodelsjobRun(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDigitalModelV1Auth0ModelsCreatemodelsjobRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDigitalModelV1Auth0ModelsCreatemodelsjobRun>>
>;
export type CreateDigitalModelV1Auth0ModelsCreatemodelsjobRunMutationBody = CreateDigitalModelRequestSchema;
export type CreateDigitalModelV1Auth0ModelsCreatemodelsjobRunMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Create Digital Model
 */
export const useCreateDigitalModelV1Auth0ModelsCreatemodelsjobRun = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDigitalModelV1Auth0ModelsCreatemodelsjobRun>>,
      TError,
      { data: CreateDigitalModelRequestSchema },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDigitalModelV1Auth0ModelsCreatemodelsjobRun>>,
  TError,
  { data: CreateDigitalModelRequestSchema },
  TContext
> => {
  return useMutation(getCreateDigitalModelV1Auth0ModelsCreatemodelsjobRunMutationOptions(options), queryClient);
};

/**
 * @summary Delete Digital Model
 */
export const deleteDigitalModelV1Auth0ModelsDigitalmodelsGuid = (modelGuid: string) => {
  return IgniteAxiosClient<unknown>({ url: `/dashboard/v1/auth0/models/digitalModels/${modelGuid}`, method: 'DELETE' });
};

export const getDeleteDigitalModelV1Auth0ModelsDigitalmodelsGuidMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ThoughtspotDeleteModelConflictResponseSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDigitalModelV1Auth0ModelsDigitalmodelsGuid>>,
    TError,
    { modelGuid: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDigitalModelV1Auth0ModelsDigitalmodelsGuid>>,
  TError,
  { modelGuid: string },
  TContext
> => {
  const mutationKey = ['deleteDigitalModelV1Auth0ModelsDigitalmodelsGuid'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDigitalModelV1Auth0ModelsDigitalmodelsGuid>>,
    { modelGuid: string }
  > = (props) => {
    const { modelGuid } = props ?? {};

    return deleteDigitalModelV1Auth0ModelsDigitalmodelsGuid(modelGuid);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDigitalModelV1Auth0ModelsDigitalmodelsGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDigitalModelV1Auth0ModelsDigitalmodelsGuid>>
>;

export type DeleteDigitalModelV1Auth0ModelsDigitalmodelsGuidMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ThoughtspotDeleteModelConflictResponseSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Delete Digital Model
 */
export const useDeleteDigitalModelV1Auth0ModelsDigitalmodelsGuid = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ThoughtspotDeleteModelConflictResponseSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDigitalModelV1Auth0ModelsDigitalmodelsGuid>>,
      TError,
      { modelGuid: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDigitalModelV1Auth0ModelsDigitalmodelsGuid>>,
  TError,
  { modelGuid: string },
  TContext
> => {
  return useMutation(getDeleteDigitalModelV1Auth0ModelsDigitalmodelsGuidMutationOptions(options), queryClient);
};

/**
 * @summary Update Digital Model
 */
export const updateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRun = (
  modelGuid: string,
  updateDigitalModelRequestSchema: UpdateDigitalModelRequestSchema,
) => {
  return IgniteAxiosClient<JobEnqueueResponseSchema>({
    url: `/dashboard/v1/auth0/models/updateModelsJob/${modelGuid}/digital:run`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateDigitalModelRequestSchema,
  });
};

export const getUpdateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRunMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRun>>,
    TError,
    { modelGuid: string; data: UpdateDigitalModelRequestSchema },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRun>>,
  TError,
  { modelGuid: string; data: UpdateDigitalModelRequestSchema },
  TContext
> => {
  const mutationKey = ['updateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRun'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRun>>,
    { modelGuid: string; data: UpdateDigitalModelRequestSchema }
  > = (props) => {
    const { modelGuid, data } = props ?? {};

    return updateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRun(modelGuid, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRun>>
>;
export type UpdateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRunMutationBody = UpdateDigitalModelRequestSchema;
export type UpdateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRunMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Update Digital Model
 */
export const useUpdateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRun = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRun>>,
      TError,
      { modelGuid: string; data: UpdateDigitalModelRequestSchema },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRun>>,
  TError,
  { modelGuid: string; data: UpdateDigitalModelRequestSchema },
  TContext
> => {
  return useMutation(getUpdateDigitalModelV1Auth0ModelsUpdatemodelsjobGuidRunMutationOptions(options), queryClient);
};

/**
 * @summary Get Share Users
 */
export const getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers = (objectId: string) => {
  return IgniteAxiosClient<ShareGetUsersResponseSchema>({
    url: `/dashboard/v1/auth0/thoughtspotObjects/${objectId}/shareUsers`,
    method: 'GET',
  });
};

export const getGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersInfiniteQueryKey = (objectId: string) => {
  return ['infinite', `/dashboard/v1/auth0/thoughtspotObjects/${objectId}/shareUsers`] as const;
};

export const getGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersQueryKey = (objectId: string) => {
  return [`/dashboard/v1/auth0/thoughtspotObjects/${objectId}/shareUsers`] as const;
};

export const getGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  objectId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersInfiniteQueryKey(objectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>
  > = () => getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers(objectId);

  return { queryKey, queryFn, enabled: !!objectId, staleTime: 10000, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>
>;
export type GetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersInfiniteQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  objectId: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
          TError,
          Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  objectId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
          TError,
          Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  objectId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Share Users
 */

export function useGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  objectId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersInfiniteQueryOptions(
    objectId,
    options,
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersQueryOptions = <
  TData = Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  objectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersQueryKey(objectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>
  > = () => getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers(objectId);

  return { queryKey, queryFn, enabled: !!objectId, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>
>;
export type GetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers<
  TData = Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  objectId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
          TError,
          Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers<
  TData = Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  objectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
          TError,
          Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers<
  TData = Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  objectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Share Users
 */

export function useGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers<
  TData = Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  objectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersQueryOptions(objectId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update Share Users
 */
export const updateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers = (
  objectId: string,
  shareRequestSchema: ShareRequestSchema,
) => {
  return IgniteAxiosClient<ShareResponseSchema>({
    url: `/dashboard/v1/auth0/thoughtspotObjects/${objectId}/shareUsers`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shareRequestSchema,
  });
};

export const getUpdateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
    TError,
    { objectId: string; data: ShareRequestSchema },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
  TError,
  { objectId: string; data: ShareRequestSchema },
  TContext
> => {
  const mutationKey = ['updateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
    { objectId: string; data: ShareRequestSchema }
  > = (props) => {
    const { objectId, data } = props ?? {};

    return updateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers(objectId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>
>;
export type UpdateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersMutationBody = ShareRequestSchema;
export type UpdateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Update Share Users
 */
export const useUpdateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
      TError,
      { objectId: string; data: ShareRequestSchema },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers>>,
  TError,
  { objectId: string; data: ShareRequestSchema },
  TContext
> => {
  return useMutation(
    getUpdateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusersMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Get Alias List
 */
export const getAliasListV1Auth0Aliases = (params?: GetAliasListV1Auth0AliasesParams) => {
  return IgniteAxiosClient<GetAliasListResponseSchema>({ url: `/dashboard/v1/auth0/aliases`, method: 'GET', params });
};

export const getGetAliasListV1Auth0AliasesInfiniteQueryKey = (params?: GetAliasListV1Auth0AliasesParams) => {
  return ['infinite', `/dashboard/v1/auth0/aliases`, ...(params ? [params] : [])] as const;
};

export const getGetAliasListV1Auth0AliasesQueryKey = (params?: GetAliasListV1Auth0AliasesParams) => {
  return [`/dashboard/v1/auth0/aliases`, ...(params ? [params] : [])] as const;
};

export const getGetAliasListV1Auth0AliasesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetAliasListV1Auth0AliasesParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAliasListV1Auth0AliasesInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>> = () =>
    getAliasListV1Auth0Aliases(params);

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAliasListV1Auth0AliasesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>
>;
export type GetAliasListV1Auth0AliasesInfiniteQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useGetAliasListV1Auth0AliasesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: undefined | GetAliasListV1Auth0AliasesParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>,
          TError,
          Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAliasListV1Auth0AliasesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetAliasListV1Auth0AliasesParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>,
          TError,
          Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAliasListV1Auth0AliasesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetAliasListV1Auth0AliasesParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Alias List
 */

export function useGetAliasListV1Auth0AliasesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetAliasListV1Auth0AliasesParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAliasListV1Auth0AliasesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetAliasListV1Auth0AliasesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetAliasListV1Auth0AliasesParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAliasListV1Auth0AliasesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>> = () =>
    getAliasListV1Auth0Aliases(params);

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAliasListV1Auth0AliasesQueryResult = NonNullable<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>>;
export type GetAliasListV1Auth0AliasesQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useGetAliasListV1Auth0Aliases<
  TData = Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: undefined | GetAliasListV1Auth0AliasesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>,
          TError,
          Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAliasListV1Auth0Aliases<
  TData = Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetAliasListV1Auth0AliasesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>,
          TError,
          Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAliasListV1Auth0Aliases<
  TData = Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetAliasListV1Auth0AliasesParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Alias List
 */

export function useGetAliasListV1Auth0Aliases<
  TData = Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetAliasListV1Auth0AliasesParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAliasListV1Auth0Aliases>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAliasListV1Auth0AliasesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create Alias
 */
export const createAliasV1Auth0Aliases = (
  createAliasApiRequestSchema: CreateAliasApiRequestSchema,
  params?: CreateAliasV1Auth0AliasesParams,
) => {
  return IgniteAxiosClient<AliasResponseSchema>({
    url: `/dashboard/v1/auth0/aliases`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createAliasApiRequestSchema,
    params,
  });
};

export const getCreateAliasV1Auth0AliasesMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAliasV1Auth0Aliases>>,
    TError,
    { data: CreateAliasApiRequestSchema; params?: CreateAliasV1Auth0AliasesParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAliasV1Auth0Aliases>>,
  TError,
  { data: CreateAliasApiRequestSchema; params?: CreateAliasV1Auth0AliasesParams },
  TContext
> => {
  const mutationKey = ['createAliasV1Auth0Aliases'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAliasV1Auth0Aliases>>,
    { data: CreateAliasApiRequestSchema; params?: CreateAliasV1Auth0AliasesParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return createAliasV1Auth0Aliases(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAliasV1Auth0AliasesMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAliasV1Auth0Aliases>>
>;
export type CreateAliasV1Auth0AliasesMutationBody = CreateAliasApiRequestSchema;
export type CreateAliasV1Auth0AliasesMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Create Alias
 */
export const useCreateAliasV1Auth0Aliases = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAliasV1Auth0Aliases>>,
      TError,
      { data: CreateAliasApiRequestSchema; params?: CreateAliasV1Auth0AliasesParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAliasV1Auth0Aliases>>,
  TError,
  { data: CreateAliasApiRequestSchema; params?: CreateAliasV1Auth0AliasesParams },
  TContext
> => {
  return useMutation(getCreateAliasV1Auth0AliasesMutationOptions(options), queryClient);
};

/**
 * @summary Get Default Alias List
 */
export const getDefaultAliasListV1Auth0Aliases = (params?: GetDefaultAliasListV1Auth0AliasesParams) => {
  return IgniteAxiosClient<GetAliasListResponseSchema>({
    url: `/dashboard/v1/auth0/aliases/default`,
    method: 'GET',
    params,
  });
};

export const getGetDefaultAliasListV1Auth0AliasesInfiniteQueryKey = (
  params?: GetDefaultAliasListV1Auth0AliasesParams,
) => {
  return ['infinite', `/dashboard/v1/auth0/aliases/default`, ...(params ? [params] : [])] as const;
};

export const getGetDefaultAliasListV1Auth0AliasesQueryKey = (params?: GetDefaultAliasListV1Auth0AliasesParams) => {
  return [`/dashboard/v1/auth0/aliases/default`, ...(params ? [params] : [])] as const;
};

export const getGetDefaultAliasListV1Auth0AliasesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetDefaultAliasListV1Auth0AliasesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDefaultAliasListV1Auth0AliasesInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>> = () =>
    getDefaultAliasListV1Auth0Aliases(params);

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDefaultAliasListV1Auth0AliasesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>
>;
export type GetDefaultAliasListV1Auth0AliasesInfiniteQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useGetDefaultAliasListV1Auth0AliasesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: undefined | GetDefaultAliasListV1Auth0AliasesParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>,
          TError,
          Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDefaultAliasListV1Auth0AliasesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetDefaultAliasListV1Auth0AliasesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>,
          TError,
          Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDefaultAliasListV1Auth0AliasesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetDefaultAliasListV1Auth0AliasesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Default Alias List
 */

export function useGetDefaultAliasListV1Auth0AliasesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetDefaultAliasListV1Auth0AliasesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDefaultAliasListV1Auth0AliasesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetDefaultAliasListV1Auth0AliasesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetDefaultAliasListV1Auth0AliasesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDefaultAliasListV1Auth0AliasesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>> = () =>
    getDefaultAliasListV1Auth0Aliases(params);

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDefaultAliasListV1Auth0AliasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>
>;
export type GetDefaultAliasListV1Auth0AliasesQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useGetDefaultAliasListV1Auth0Aliases<
  TData = Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: undefined | GetDefaultAliasListV1Auth0AliasesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>,
          TError,
          Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDefaultAliasListV1Auth0Aliases<
  TData = Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetDefaultAliasListV1Auth0AliasesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>,
          TError,
          Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDefaultAliasListV1Auth0Aliases<
  TData = Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetDefaultAliasListV1Auth0AliasesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Default Alias List
 */

export function useGetDefaultAliasListV1Auth0Aliases<
  TData = Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetDefaultAliasListV1Auth0AliasesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultAliasListV1Auth0Aliases>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDefaultAliasListV1Auth0AliasesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update Alias
 */
export const updateAliasV1Auth0AliasesId = (
  aliasId: string,
  updateAliasApiRequestSchema: UpdateAliasApiRequestSchema,
  params?: UpdateAliasV1Auth0AliasesIdParams,
) => {
  return IgniteAxiosClient<AliasResponseSchema>({
    url: `/dashboard/v1/auth0/aliases/${aliasId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateAliasApiRequestSchema,
    params,
  });
};

export const getUpdateAliasV1Auth0AliasesIdMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAliasV1Auth0AliasesId>>,
    TError,
    { aliasId: string; data: UpdateAliasApiRequestSchema; params?: UpdateAliasV1Auth0AliasesIdParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAliasV1Auth0AliasesId>>,
  TError,
  { aliasId: string; data: UpdateAliasApiRequestSchema; params?: UpdateAliasV1Auth0AliasesIdParams },
  TContext
> => {
  const mutationKey = ['updateAliasV1Auth0AliasesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAliasV1Auth0AliasesId>>,
    { aliasId: string; data: UpdateAliasApiRequestSchema; params?: UpdateAliasV1Auth0AliasesIdParams }
  > = (props) => {
    const { aliasId, data, params } = props ?? {};

    return updateAliasV1Auth0AliasesId(aliasId, data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAliasV1Auth0AliasesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAliasV1Auth0AliasesId>>
>;
export type UpdateAliasV1Auth0AliasesIdMutationBody = UpdateAliasApiRequestSchema;
export type UpdateAliasV1Auth0AliasesIdMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Update Alias
 */
export const useUpdateAliasV1Auth0AliasesId = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAliasV1Auth0AliasesId>>,
      TError,
      { aliasId: string; data: UpdateAliasApiRequestSchema; params?: UpdateAliasV1Auth0AliasesIdParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAliasV1Auth0AliasesId>>,
  TError,
  { aliasId: string; data: UpdateAliasApiRequestSchema; params?: UpdateAliasV1Auth0AliasesIdParams },
  TContext
> => {
  return useMutation(getUpdateAliasV1Auth0AliasesIdMutationOptions(options), queryClient);
};

/**
 * @summary Delete Alias
 */
export const deleteAliasV1Auth0AliasesId = (aliasId: string, params?: DeleteAliasV1Auth0AliasesIdParams) => {
  return IgniteAxiosClient<DeleteAliasResponseSchema>({
    url: `/dashboard/v1/auth0/aliases/${aliasId}`,
    method: 'DELETE',
    params,
  });
};

export const getDeleteAliasV1Auth0AliasesIdMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAliasV1Auth0AliasesId>>,
    TError,
    { aliasId: string; params?: DeleteAliasV1Auth0AliasesIdParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAliasV1Auth0AliasesId>>,
  TError,
  { aliasId: string; params?: DeleteAliasV1Auth0AliasesIdParams },
  TContext
> => {
  const mutationKey = ['deleteAliasV1Auth0AliasesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAliasV1Auth0AliasesId>>,
    { aliasId: string; params?: DeleteAliasV1Auth0AliasesIdParams }
  > = (props) => {
    const { aliasId, params } = props ?? {};

    return deleteAliasV1Auth0AliasesId(aliasId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAliasV1Auth0AliasesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAliasV1Auth0AliasesId>>
>;

export type DeleteAliasV1Auth0AliasesIdMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Delete Alias
 */
export const useDeleteAliasV1Auth0AliasesId = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAliasV1Auth0AliasesId>>,
      TError,
      { aliasId: string; params?: DeleteAliasV1Auth0AliasesIdParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAliasV1Auth0AliasesId>>,
  TError,
  { aliasId: string; params?: DeleteAliasV1Auth0AliasesIdParams },
  TContext
> => {
  return useMutation(getDeleteAliasV1Auth0AliasesIdMutationOptions(options), queryClient);
};

/**
 * @summary Get Categories List
 */
export const getCategoriesListV1Auth0 = (params?: GetCategoriesListV1Auth0Params) => {
  return IgniteAxiosClient<GetCategoriesListResponseSchema>({
    url: `/dashboard/v1/auth0/categories`,
    method: 'GET',
    params,
  });
};

export const getGetCategoriesListV1Auth0InfiniteQueryKey = (params?: GetCategoriesListV1Auth0Params) => {
  return ['infinite', `/dashboard/v1/auth0/categories`, ...(params ? [params] : [])] as const;
};

export const getGetCategoriesListV1Auth0QueryKey = (params?: GetCategoriesListV1Auth0Params) => {
  return [`/dashboard/v1/auth0/categories`, ...(params ? [params] : [])] as const;
};

export const getGetCategoriesListV1Auth0InfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetCategoriesListV1Auth0Params,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCategoriesListV1Auth0InfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>> = () =>
    getCategoriesListV1Auth0(params);

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCategoriesListV1Auth0>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoriesListV1Auth0InfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCategoriesListV1Auth0>>
>;
export type GetCategoriesListV1Auth0InfiniteQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useGetCategoriesListV1Auth0Infinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: undefined | GetCategoriesListV1Auth0Params,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoriesListV1Auth0>>,
          TError,
          Awaited<ReturnType<typeof getCategoriesListV1Auth0>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoriesListV1Auth0Infinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetCategoriesListV1Auth0Params,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoriesListV1Auth0>>,
          TError,
          Awaited<ReturnType<typeof getCategoriesListV1Auth0>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoriesListV1Auth0Infinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetCategoriesListV1Auth0Params,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Categories List
 */

export function useGetCategoriesListV1Auth0Infinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetCategoriesListV1Auth0Params,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCategoriesListV1Auth0InfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetCategoriesListV1Auth0QueryOptions = <
  TData = Awaited<ReturnType<typeof getCategoriesListV1Auth0>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetCategoriesListV1Auth0Params,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCategoriesListV1Auth0QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>> = () =>
    getCategoriesListV1Auth0(params);

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCategoriesListV1Auth0>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoriesListV1Auth0QueryResult = NonNullable<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>>;
export type GetCategoriesListV1Auth0QueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useGetCategoriesListV1Auth0<
  TData = Awaited<ReturnType<typeof getCategoriesListV1Auth0>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: undefined | GetCategoriesListV1Auth0Params,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoriesListV1Auth0>>,
          TError,
          Awaited<ReturnType<typeof getCategoriesListV1Auth0>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoriesListV1Auth0<
  TData = Awaited<ReturnType<typeof getCategoriesListV1Auth0>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetCategoriesListV1Auth0Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoriesListV1Auth0>>,
          TError,
          Awaited<ReturnType<typeof getCategoriesListV1Auth0>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoriesListV1Auth0<
  TData = Awaited<ReturnType<typeof getCategoriesListV1Auth0>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetCategoriesListV1Auth0Params,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Categories List
 */

export function useGetCategoriesListV1Auth0<
  TData = Awaited<ReturnType<typeof getCategoriesListV1Auth0>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params?: GetCategoriesListV1Auth0Params,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesListV1Auth0>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCategoriesListV1Auth0QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
